export const floatInputType = {
  phoneNumber: "phone-number",
};
